import React, {
  useEffect,
  useMemo,
  useReducer,
  useRef,
  useState,
  useCallback,
} from "react";
import { WorkflowToolbar } from "../../components/WorkflowToolbar";
import { Button, Text, LinearProgress } from "../../components";
import rison from "rison";
import { TaskType } from "../../utils/constants";
import { useDevicePixelRatio } from "use-device-pixel-ratio";
import { IconButton, Tabs, Tab } from "@material-ui/core";
import { Helmet } from "react-helmet";
import _ from "lodash";
import WorkflowDAG from "../../components/diagram/WorkflowDAG";
import WorkflowGraph from "../../components/diagram/WorkflowGraph";
import ResetConfirmationDialog from "./ResetConfirmationDialog";
import { useWorkflowEditor } from "../../hooks/useWorkflowEditor";
import { JSON_FILE_NAME } from "../../schema/workflow";
import SaveWorkflowDialog from "./SaveWorkflowDialog";
import update from "immutability-helper";
import { usePushHistory } from "../../components/NavLink";
import {
  deleteTaskFromList,
  getTaskObj,
  updateTaskList,
  splitTaskReferenceName,
  findJoinNode,
} from "../../utils/helpers";

import {
  KeyboardArrowLeftRounded,
  KeyboardArrowRightRounded,
} from "@material-ui/icons";
import WorkflowDefinationForm from "./WorkflowDefinationForm";
import TaskDefinationTab from "./TaskDefinationTab";
import TaskPopperUi from "../../components/tasklistpopperui/TaskPopperUi";
import SwitchTaskPopperUI from "../../components/tasklistpopperui/SwitchTaskPopperUI";
import { generateRandomText } from "../../utils/helpers";
import ConfirmChoiceDialog from "../../components/ConfirmChoiceDialog";
import SwitchCasesPopperUI from "../../components/tasklistpopperui/SwitchCasesPopperUI";
import ForkPathsPopperUI from "../../components/tasklistpopperui/ForkPathsPopperUI";
import { getUserDetails } from "../../config";
// import { split } from "cypress/types/lodash";
import Split from "react-split";
import {
  actions,
  initialState,
  DEFAULT_SPLIT_SIZES,
  DEFAULT_SPLIT_MIN_SIZES,
  DEFAULT_SPLIT_MAX_SIZES,
  DEFAULT_GUTTER_SIZE,
  DEFAULT_DPR,
  NODE_CLICK_LOADING_DELAY,
  TASK_CREATION_DELAY,
} from "../../data/constants/workflowDefConstants";
import useStyles from "./workflowDefStyles";
import { WorkflowErrors } from "../../contexts/WorkflowErrors";
import {
  createTaskNode,
  createSwitchComponent,
  createForkComponent,
  createDoWhileComponent,
  createSubWorkflowComponent,
  createTriggerApprovalComponent,
} from "../../utils/taskNodeCreators";
import { createSubWorkflowTemplates } from "../../data/constants/taskTemplates";
import { useWorkflowDuration } from "../../hooks/useWorkflowDuration";
import { useWorkflowDefinitionData } from "../../hooks/useWorkflowDefinitionData";
import SafeEditor from "../../components/SafeEditor";
function workflowDefStateReducer(state, action) {
  switch (action.type) {
    case actions.TOGGLE_GRAPH_PANEL:
      return update(state, {
        toggleGraphPanel: {
          $set: !state.toggleGraphPanel,
        },
      });
    case actions.UPDATE_CODE_PANEL_WIDTH:
      return update(state, {
        workflowCodePanelWidth: {
          $set: `${action.newWidth}px`,
        },
      });
    default:
      return state;
  }
}

export default function WorkflowDefinition(props) {
  const permissions = props?.permissions;
  const {
    wfData,
    workflowDef,
    isFetching,
    versions,
    selectedVersion,
    validSelectedVersion,
    workflowVersion,
    workflowName,
    refetchNamesAndVersions,
    refetchwfVersions,
  } = useWorkflowDefinitionData();

  // Use the editor hook
  const {
    isEditorMounted,
    decorations,
    hasEditorLoaded,
    jsonErrors,
    jsonParseError,
    isCodeModified,
    newWorkflow,
    editorRef,
    debouncedHandleChange,
    handleEditorWillMount,
    handleEditorDidMount,
    handleValidate,
    handleJsonErrors,
    handleEditorChange,
    setDecorations,
    setIsCodeModified,
  } = useWorkflowEditor();

  const navigate = usePushHistory();
  const [saveDialog, setSaveDialog] = useState(null);
  const [resetDialog, setResetDialog] = useState(false); // false=idle, undefined=current_version, otherwise version id
  const [isModified, setIsModified] = useState(null);
  const [dag, setDag] = useState(null);
  const [taskErrors, setTaskErrors] = React.useContext(WorkflowErrors);
  const [splitSizes, setSplitSizes] = useState(DEFAULT_SPLIT_SIZES);
  const [splitMinSizes, setSplitMinSizes] = useState(DEFAULT_SPLIT_MIN_SIZES);
  const [splitMaxSizes, setSplitMaxSizes] = useState(DEFAULT_SPLIT_MAX_SIZES);
  const dpr = useDevicePixelRatio({ defaultDpr: DEFAULT_DPR });
  const [value, setValue] = useState(0);
  const workflowFormRef = useRef();
  const [dataToBeAddedToJSON, setDataToBeAddedToJson] = useState(initialState);
  const [tasks, setTasks] = useState([]);
  const [clickedWorkflowNodeTaskRef, setClickedWorkflowNodeTaskRef] =
    useState(null);
  const [selectedTaskRison, setSelectedTaskRison] = useState("");
  const [clickedAddBtnNode, setClickedAddBtnNode] = useState("");
  const [clickedDeletePathBtnNode, setClickedDeletePathBtnNode] = useState("");
  const [clickedDeleteBtnNode, setClickedDeleteBtnNode] = useState({
    ref: null,
    openDialog: false,
    header: "",
    message: "",
  });
  const [showTasksPopper, setShowTasksPopper] = useState(false);
  const [taskSelectedFromList, setTaskSelectedFromList] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [isTaskDataLoading, setIsTaskDataLoading] = useState(false);
  const [taskData, setTaskData] = useState("");
  const [clickedTask, setClickedTask] = useState("");
  const [nodeClicked, setNodeClicked] = useState(null);

  const [setEditorDelay, editorDelay] = useState(false);

  // Duration management using custom hook
  const {
    duration,
    workflowDays,
    workflowHours,
    workflowMinutes,
    workflowSeconds,
    setDuration,
    setWorkflowDays,
    setWorkflowHours,
    setWorkflowMinutes,
    setWorkflowSeconds,
    handleDaysChange,
    handleHoursChange,
    handleMinutesChange,
    handleSecondsChange,
  } = useWorkflowDuration(setIsModified);

  const permissionConfig = useMemo(() => {
    return {
      canCreateWorkflow:
        permissions?.workflows?.actions?.create_workflow === "True",
      canCreateTask: permissions?.tasks?.actions?.create_task === "True",
      canAccessCodeEditor: permissions?.workflows?.actions?.code !== "False",
    };
  }, [permissions]);

  const updateLoading = useCallback((status) => {
    setLoading(status);
  }, []);

  const [workflowDefState, dispatch] = useReducer(workflowDefStateReducer, {
    workflowCodePanelWidth: "50%",
    toggleGraphPanel: true,
  });

  const [selectedForkCase, setSelectedForkCase] = useState(null);
  const classes = useStyles(workflowDefState);

  const handleResetWorkflowTab = () => {
    if (workflowFormRef.current) {
      workflowFormRef.current.resetForm();
    }
  };

  const prevWorkflowJson = useMemo(() => {
    const olderWorkflow = _.cloneDeep(workflowDef);
    if (olderWorkflow) {
      const version = olderWorkflow.version;
      const keepAttrForTasks = olderWorkflow.tasks.map(
        ({ category, startDelay, schemaName, ...keepAttrs }) => keepAttrs
      );

      const modifiedTasks = keepAttrForTasks.map((task) => {
        const sorted_obj = Object.keys(task)
          .sort()
          .reduce((temp_obj, key) => {
            temp_obj[key] = task[key];
            return temp_obj;
          }, {});
        return sorted_obj;
      });

      let details = olderWorkflow;
      if (version === 1 && olderWorkflow.createTime) {
        details = _.omit(olderWorkflow, "updateTime");
        details.updateTime = olderWorkflow.createTime;
      }
      const dataAdded = _.omit(dataToBeAddedToJSON, "version");
      delete dataAdded.version;

      const json = {
        ...dataAdded,
        ...details,
        tasks: modifiedTasks,
        timeoutPolicy: olderWorkflow?.timeoutPolicy ? olderWorkflow?.timeoutPolicy
          : undefined,

        ttlSeconds: duration,
      };

      const modifiedJson = {};
      const allKeys = Object.keys(json);
      allKeys.sort();
      for (let i = 0; i < allKeys.length; i++) {
        modifiedJson[allKeys[i]] = json[allKeys[i]];
      }

      return JSON.stringify(modifiedJson, null, 2);
    }
  }, [
    workflowDef,
    dataToBeAddedToJSON,
    tasks,
    workflowDays,
    workflowHours,
    workflowMinutes,
    workflowSeconds,
  ]);

  const workflowJson = useMemo(() => {
    if (workflowDef && tasks) {
      const keepAttrForTasks = tasks
        ? tasks.map((task) => {
          if (task) {
            const {
              category,
              startDelay,
              schemaName,
              updateTime,
              ...keepAttrs
            } = task;
            return keepAttrs;
          }
          return {};
        })
        : [];

      const modifiedTasks = keepAttrForTasks.map((task) => {
        const sorted_obj = Object.keys(task)
          .sort()
          .reduce((temp_obj, key) => {
            temp_obj[key] = task[key];
            return temp_obj;
          }, {});
        return sorted_obj;
      });

      let updateTime;
      const version = prevWorkflowJson.version;

      if (version !== 1 && workflowDef.createTime && !updateTime) {
        updateTime = Date.now();
      } else if (version === 1 && workflowDef.createTime) {
        updateTime = workflowDef.createTime;
      }
      const dataAdded = _.omit(dataToBeAddedToJSON, "version");
      delete dataAdded.version;
      const json = {
        ...workflowDef,
        updateTime: updateTime,
        tasks: modifiedTasks,
        ...dataAdded,
        timeoutPolicy: dataToBeAddedToJSON?.timeoutPolicy ? dataToBeAddedToJSON?.timeoutPolicy
          : undefined,

        ttlSeconds: duration,
      };
      const modifiedJson = {};
      const allKeys = Object.keys(json);
      allKeys.sort();
      for (let i = 0; i < allKeys.length; i++) {
        modifiedJson[allKeys[i]] = json[allKeys[i]];
      }
      setDag(new WorkflowDAG(null, json));
      return JSON.stringify(modifiedJson, null, 2);
    }
    // else if (!workflowDef){
    //     navigate('/workflowDefs?error=true')
    // }
  }, [
    workflowDef,
    dataToBeAddedToJSON,
    tasks,
    duration,
    workflowDays,
    workflowHours,
    workflowMinutes,
    workflowSeconds,
  ]);

  const workflowJsonWithoutSubWf = useMemo(() => {
    if (workflowDef && tasks) {
      // Filter out tasks with isSubWF === true
      const newTasks = tasks ? _.cloneDeep(tasks) : [];
      const filteredTasks = newTasks.filter(
        (task) =>
          task &&
          ((!task.isSubWF && task.name !== "LABEL_END_SUB_WORKFLOW") ||
            task.type === "SUB_WORKFLOW")
      );

      const keepAttrForTasks = filteredTasks.map((task) => {
        if (task) {
          const { category, startDelay, schemaName, updateTime, ...keepAttrs } =
            task;
          return keepAttrs;
        }
        return {};
      });

      const modifiedTasks = keepAttrForTasks.map((task) => {
        const sortedTask = Object.keys(task)
          .sort()
          .reduce((sortedObj, key) => {
            sortedObj[key] = task[key];
            return sortedObj;
          }, {});
        return sortedTask;
      });

      let updateTime;
      const version = prevWorkflowJson.version;

      if (version !== 1 && workflowDef.createTime && !updateTime) {
        updateTime = Date.now();
      } else if (version === 1 && workflowDef.createTime) {
        updateTime = workflowDef.createTime;
      }

      const dataAdded = _.omit(dataToBeAddedToJSON, "version");
      const json = {
        ...workflowDef,
        updateTime,
        tasks: modifiedTasks,
        ...dataAdded,
        timeoutPolicy: dataToBeAddedToJSON?.timeoutPolicy ? dataToBeAddedToJSON?.timeoutPolicy
          : undefined,

        ttlSeconds: duration,
      };

      const sortedJson = Object.keys(json)
        .sort()
        .reduce((sortedObj, key) => {
          sortedObj[key] = json[key];
          return sortedObj;
        }, {});

      return JSON.stringify(sortedJson, null, 2);
    }
  }, [workflowDef, dataToBeAddedToJSON, tasks, duration]);

  const workflowDisplayName = useMemo(() => {
    if (workflowJson) {
      const parsedJson = JSON.parse(workflowJson);
      const { workflowName } = parsedJson;
      return workflowName;
    }
  }, [workflowJson]);

  const inputParameters = useMemo(() => {
    if (workflowJson) {
      const parsedJson = JSON.parse(workflowJson);
      const { inputParameters } = parsedJson;
      return inputParameters;
    }
  }, [workflowJson]);

  useEffect(() => {
    if (workflowDef) {
      setDag(new WorkflowDAG(null, workflowDef));
    }
  }, [workflowDef]);

  // Version Change or Reset
  const handleResetVersion = (version) => {
    if (isModified) {
      setResetDialog(version);
    } else {
      changeVersionOrReset(version);
    }
  };

  const changeVersionOrReset = (version) => {
    if (_.isUndefined(workflowName) && version == null) {
      setTasks([..._.cloneDeep(workflowDef.tasks)]);
      // setShouldResetWorklow(true); dead
      handleResetWorkflowTab();
      const clickedTaskObj = workflowDef.tasks.find(
        (task) => task.type !== "LABEL"
      );
      setClickedTask(clickedTaskObj);
      setTaskData(clickedTaskObj);

      setResetDialog(false);
      setIsModified(false);
      setTaskErrors([]);
      setSelectedTaskRison("");
    } else {
      setResetDialog(false);
      setIsModified(false);
      setTaskErrors([]);
      setSelectedTaskRison("");
      if (version === workflowVersion) {
        // Reset to fetched version

        if (editorRef?.current?.getModel()) {
          for (let ele in dataToBeAddedToJSON) {
            setDataToBeAddedToJson((prevState) => ({
              ...prevState,
              [ele]: workflowDef[ele],
            }));
          }

          setTasks([..._.cloneDeep(workflowDef.tasks)]);
          const clickedTaskObj = workflowDef.tasks.find(
            (task) => task.type !== "LABEL"
          );
          setClickedTask(clickedTaskObj);

          setTaskData(clickedTaskObj);
          // setValue(0);
          if (_.isUndefined(version)) {
            navigate(`/workflowDef/${workflowName}`);
          } else {
            navigate(`/workflowDef/${workflowName}/${version}`);
          }
        }
      } else if (_.isUndefined(version)) {
        navigate(`/workflowDef/${workflowName}`);
      } else if (version) {
        navigate(`/workflowDef/${workflowName}/${version}`);
      } else {
        navigate(`/workflowDef/${workflowName}`);
      }
    }
  };

  const handleOpenSave = () => {
    const modified = editorRef?.current?.getValue();
    if (!modified) return;
    var jsonObject = JSON.parse(modified);

    let loggedInUserEMail = getUserDetails().userEmail;

    if (loggedInUserEMail !== "example@localhost.com") {
      jsonObject.updatedBy = loggedInUserEMail;
    }

    if (jsonObject.createdBy === "example@localhost.com") {
      jsonObject.createdBy = jsonObject?.ownerEmail;
    }

    let updateTime;
    const version = prevWorkflowJson.version;
    if (version !== 1 && workflowDef.createTime) {
      updateTime = Date.now();
    } else if (version === 1 && workflowDef.createTime) {
      updateTime = workflowDef.createTime;
    }
    jsonObject.updateTime = updateTime;
    function transformTasks(tasks) {
      // Filter out tasks with issubwf === true or "LABEL_END_SUB_WORKFLOW" unless type is "SUB_WORKFLOW"
      const filteredTasks = tasks.filter(
        (task) =>
          (!task.isSubWF && task.name !== "LABEL_END_SUB_WORKFLOW") ||
          task.type === "SUB_WORKFLOW"
      );

      // Remove unwanted attributes and keep necessary ones
      const keepAttrForTasks = filteredTasks.map(
        ({ category, startDelay, schemaName, updateTime, ...keepAttrs }) =>
          keepAttrs
      );

      // Sort remaining attributes of each task
      const modifiedTasks = keepAttrForTasks.map((task) => {
        const sortedTask = Object.keys(task)
          .sort()
          .reduce((sortedObj, key) => {
            sortedObj[key] = task[key];
            return sortedObj;
          }, {});
        return sortedTask;
      });

      return modifiedTasks;
    }

    // Apply the transformation to the tasks array
    jsonObject.tasks = transformTasks(jsonObject.tasks);

    // If there are decision cases or default cases within any task, apply the transformation to those as well
    jsonObject.tasks = jsonObject.tasks.map((task) => {
      if (task.decisionCases) {
        for (let key in task.decisionCases) {
          task.decisionCases[key] = transformTasks(task.decisionCases[key]);
        }
      }
      if (task.defaultCase) {
        task.defaultCase = transformTasks(task.defaultCase);
      }
      return task;
    });

    // Sorting the attributes of the final JSON object
    const sortedWorkflowObj = Object.keys(jsonObject)
      .sort()
      .reduce((sortedObj, key) => {
        sortedObj[key] = jsonObject[key];
        return sortedObj;
      }, {});

    // Convert the sorted JSON object to a string with pretty formatting
    const finalJson = JSON.stringify(sortedWorkflowObj, null, 2);
    // var modifiedJsonData = JSON.stringify(jsonObject);

    setSaveDialog({
      // original: workflowName ? workflowJson : "",
      original: workflowName ? prevWorkflowJson : "",
      originalObj: workflowName ? workflowDef : null,
      modified: finalJson,
    });
    // setLastSavedCode(finalJson);
  };
  const handleSaveCancel = () => {
    setSaveDialog(null);
  };

  const handleSaveSuccess = (name, version) => {
    setSaveDialog(null);
    setIsCodeModified(false);
    setIsModified(false);
    refetchNamesAndVersions();
    refetchwfVersions();
    navigate(`/workflowDef/${name}/${version}`);
  };

  // Monaco Handlers are now in useWorkflowEditor hook

  // Editor change handlers are now in useWorkflowEditor hook

  const selectedTask = useMemo(
    () => selectedTaskRison && rison.decode(selectedTaskRison),
    [selectedTaskRison]
  );
  const handleExpandChange = () => {
    const addIsSubWF = (task) => {
      const modifiedTask = { ...task, isSubWF: true };

      if (modifiedTask.decisionCases) {
        Object.keys(modifiedTask.decisionCases).forEach((key) => {
          modifiedTask.decisionCases[key] =
            modifiedTask.decisionCases[key].map(addIsSubWF);
        });
      }

      ["defaultCase", "loopOver", "forkTasks"].forEach((key) => {
        if (modifiedTask[key]) {
          modifiedTask[key] = modifiedTask[key].map(addIsSubWF);
        }
      });

      return modifiedTask;
    };

    var currentTask = tasks.find(
      (e) => e.taskReferenceName === selectedTask?.ref
    );
    var currentTaskSubWFName = currentTask.subWorkflowParam.name;

    const wf = wfData.find((e) => e.name === currentTaskSubWFName);
    if (wf) {
      const wfTasks = wf.tasks;
      const index = tasks.findIndex(
        (e) => e.taskReferenceName === selectedTask?.ref
      );

      const { startWFTask, endWFTask } = createSubWorkflowTemplates();

      if (index !== -1) {
        const previousTask = { ...tasks[index], isSubWF: true };
        const newTasks = [
          ...tasks.slice(0, index),
          previousTask,
          startWFTask,
          ...wfTasks.map(addIsSubWF),
          endWFTask,
          ...tasks.slice(index + 1),
        ];
        setTasks(newTasks);
      }
    }
  };

  const handleCollapseChange = () => {
    let originalTasks = tasks
      .filter((task) => !task.isSubWF || task.type === "SUB_WORKFLOW")
      .filter((task) => !(task.name === "LABEL_END_SUB_WORKFLOW"));

    const index = originalTasks.findIndex(
      (e) => e.taskReferenceName === selectedTask?.ref
    );

    if (index !== -1) {
      originalTasks[index] = { ...originalTasks[index] };
      delete originalTasks[index].isSubWF;
    }

    setTasks(originalTasks);
  };
  const handleWorkflowNodeClick = (node) => {
    setLoading(true);
    if (node.ref) {
      if (
        splitTaskReferenceName(selectedTask?.ref) ===
        splitTaskReferenceName(node.ref)
      ) {
        setLoading(false);
        if (value !== 1) setValue(1);
        return;
      }
      let taskObj = getTaskObj(tasks, node.ref);
      setNodeClicked(taskObj);
      if (
        taskObj &&
        (taskObj.name === TaskType.EndOfSwitch ||
          taskObj.name === TaskType.SwitchCase ||
          taskObj.name === TaskType.Default ||
          taskObj.name === TaskType.ForkBranch ||
          taskObj.name === TaskType.EndOfForkJoin ||
          taskObj.name === TaskType.EndOfDoWhile ||
          taskObj.name === TaskType.Label ||
          (taskObj.isSubWF === true && taskObj.name !== TaskType.SubWorkflow))
      ) {
        setLoading(false);
        return;
      }
    }

    let editor = editorRef?.current?.getModel() || null;
    if (!editor) return;
    let searchResult = editor.findMatches(`"taskReferenceName": "${node.ref}"`);
    if (searchResult.length) {
      editorRef.current.revealLineInCenter(
        searchResult[0]?.range?.startLineNumber,
        0
      );
      setDecorations(
        editorRef.current.deltaDecorations(decorations, [
          {
            range: searchResult[0]?.range,
            options: {
              isWholeLine: true,
              inlineClassName: classes.editorLineDecorator,
            },
          },
        ])
      );
      setClickedWorkflowNodeTaskRef(node.ref);
      setSelectedTaskRison(rison.encode(node));
      setValue(1);
      setTimeout(() => {
        setLoading(false);
      }, NODE_CLICK_LOADING_DELAY);
    } else {
      setLoading(false);
    }
  };

  const handleWorkflowAddBtnClick = (nodeRefObj) => {
    setClickedAddBtnNode(nodeRefObj.ref);
    setShowTasksPopper(true);
  };

  const handleSwitchCaseDeleteBtnClick = (nodeRefObj) => {
    setClickedDeletePathBtnNode(nodeRefObj.ref);
    setShowTasksPopper(true);
  };

  const handleWorkflowDeleteBtnClick = (nodeRefObj) => {
    setClickedDeleteBtnNode({
      ref: nodeRefObj.ref,
      openDialog: true,
      header: "Confirmation",
      message: "Are you sure you want to delete this task?",
    });
  };

  const handleConfirmDelete = (val) => {
    const { ref, confirm } = val;
    if (confirm) {
      const str = ref;
      const match = splitTaskReferenceName(ref);
      let endSwitchTaskRerenceName = "";
      let endDoWhileTaskReferenceName = "";
      let joinTaskReferenceName = "";
      if (
        str.startsWith(TaskType.Switch) &&
        !str.startsWith(TaskType.SwitchCase) &&
        !str.startsWith(TaskType.SwitchCase)
      ) {
        endSwitchTaskRerenceName = `${TaskType.EndOfSwitch}_${match}_ref`;
      } else if (str.startsWith(TaskType.DoWhile)) {
        endDoWhileTaskReferenceName = `${TaskType.EndOfDoWhile}_${match}_ref`;
      } else if (str.startsWith(TaskType.ForkJoin)) {
        const { tasks: allTasks, taskIndex } = findNode(tasks, ref);
        let joinNode = allTasks[taskIndex + 1];
        joinTaskReferenceName = joinNode ? joinNode.taskReferenceName : "";
      }

      const taskListAfterDelete = deleteTaskFromList(tasks, ref);

      setTasks(taskListAfterDelete);

      if (endSwitchTaskRerenceName) {
        var deletedTasks = taskListAfterDelete.filter(
          (item) => item.taskReferenceName !== endSwitchTaskRerenceName
        );
        setTasks(deletedTasks);
      }

      if (endDoWhileTaskReferenceName) {
        var deletedTasks = taskListAfterDelete.filter(
          (item) => item.taskReferenceName !== endDoWhileTaskReferenceName
        );
        setTasks(deletedTasks);
      }

      if (joinTaskReferenceName) {
        var deletedTasks = taskListAfterDelete.filter(
          (item) => item.taskReferenceName !== joinTaskReferenceName
        );
        setTasks(deletedTasks);
      }

      setClickedDeleteBtnNode({
        ref: null,
        openDialog: false,
        header: "",
        message: "",
      });
      setValue(0);
      setTimeout(() => {
        let errorArr = [...taskErrors];
        errorArr = errorArr.filter((e) => e.fieldId.split("_")[1] !== match);
        setTaskErrors(errorArr);
      }, 100);
    } else {
      setClickedDeleteBtnNode({
        ref: null,
        openDialog: false,
        header: "",
        message: "",
      });
      setValue(0);
    }
  };

  const reIndexForkPaths = (data) => {
    let dataToBeModified = data;
    if (dataToBeModified && dataToBeModified.forkTasks) {
      for (let i = 0; i < dataToBeModified.forkTasks.length; i++) {
        let forkBranch = dataToBeModified.forkTasks[i];
        if (forkBranch && forkBranch.length > 1) {
          let forkNode = forkBranch[0];
          forkNode.displayName = "Fork Path " + `${i + 1}`;
        }
      }
    }
    setTasks(_.cloneDeep(tasks));
  };

  const handleDeleteForkPath = (parentTask, selectedForkCase) => {
    deleteForkPathFromTask(parentTask, selectedForkCase);
    setTasks(_.cloneDeep(tasks)); // Update state with new fork tasks
    setTimeout(() => {
      handleWorkflowNodeClick({ ref: parentTask.taskReferenceName });
    }, TASK_CREATION_DELAY);
  };

  const deleteForkPathFromTask = (
    parentTask,
    selectedForkCase,
    onDeleteCallback
  ) => {
    let { task } = findNode(tasks, parentTask.taskReferenceName);
    if (task && task.type === TaskType.ForkJoin) {
      if (!task.forkTasks || _.isEmpty(task.forkTasks)) {
        task.forkPaths = [[]];
      }

      task.forkTasks.splice(selectedForkCase, 1);
      let joinNode = findJoinNode(tasks, task.taskReferenceName);
      joinNode.forkTasks = task.forkTasks;
      let lastTaskRefs = task.forkTasks.map((r) => _.last(r).taskReferenceName);
      if (joinNode.joinOn) {
        var filtered = joinNode.joinOn.filter(function (element) {
          return lastTaskRefs.indexOf(element) === -1;
        });

        let excludedArr = joinNode.joinOn.filter(
          (el) => !filtered.includes(el)
        );
        joinNode.joinOn = excludedArr;
      }
    }

    setTasks(_.cloneDeep(tasks));
    reIndexForkPaths(parentTask);
    closeTasksPopper();

    // Trigger the callback to inform that a fork path was deleted
    if (onDeleteCallback) {
      onDeleteCallback();
    }
  };

  const handleTabChange = (event, newValue) => {
    setValue(newValue);
    if (workflowJson) {
      if (newValue !== 2 && editorRef?.current?.getModel()) {
        editorRef.current.getModel().setValue(workflowJson);
        if (debouncedHandleChange.current)
          debouncedHandleChange.current.cancel();
      }

      var modifiedWorkflowJson;
      var detaisl;

      if (workflowJson) {
        modifiedWorkflowJson = _.omit(JSON.parse(workflowJson), "updateTime");
      }

      if (prevWorkflowJson) {
        detaisl = _.omit(JSON.parse(prevWorkflowJson), "updateTime");
      }

      setIsModified(!_.isEqual(detaisl, modifiedWorkflowJson));
    }
  };

  const handleTaskSelectedFromList = (selectedTask) => {
    setTaskSelectedFromList(selectedTask);
  };

  useEffect(() => {
    if (workflowDef) {
      for (let ele in dataToBeAddedToJSON) {
        setDataToBeAddedToJson((prevState) => ({
          ...prevState,
          [ele]: workflowDef[ele],
        }));
      }
      setTasks([...workflowDef.tasks]);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [workflowDef]); // On initial load of workflowDef we are overriding the values from workflowDef to dataAddedtoJson

  useEffect(() => {
    let modifiedWorkflowJson;
    let details;

    if (workflowJson) {
      modifiedWorkflowJson = _.omit(JSON.parse(workflowJson), "updateTime");
    }

    if (prevWorkflowJson) {
      details = _.omit(JSON.parse(prevWorkflowJson), "updateTime");
    }

    if (hasEditorLoaded) {
      setIsModified(!_.isEqual(details, modifiedWorkflowJson));
    }
    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataToBeAddedToJSON]);

  useEffect(() => {
    if (
      tasks &&
      tasks.length === 1 &&
      hasEditorLoaded &&
      splitTaskReferenceName(selectedTask?.ref) !==
      splitTaskReferenceName(tasks[0].taskReferenceName)
    ) {
      handleWorkflowNodeClick({ ref: tasks[0].taskReferenceName || "" });
    } else if (
      tasks &&
      tasks.length &&
      workflowName &&
      workflowVersion &&
      hasEditorLoaded &&
      !selectedTask
    ) {
      const clickedTaskObj = tasks.find((task) => task.type !== "LABEL");
      handleWorkflowNodeClick({ ref: clickedTaskObj.taskReferenceName || "" });
    }

    if (hasEditorLoaded) {
      var modifiedWorkflowJson;
      var detaisl;

      if (workflowJson) {
        modifiedWorkflowJson = _.omit(JSON.parse(workflowJson), "updateTime");
        modifiedWorkflowJson = _.omit(
          modifiedWorkflowJson,
          "tasks[0].mapTicketIdToWorkflow"
        );
        modifiedWorkflowJson = _.omit(
          modifiedWorkflowJson,
          "tasks[0].requestId"
        );

        modifiedWorkflowJson.name = _.isNull(modifiedWorkflowJson.name)
          ? ""
          : modifiedWorkflowJson.name;
      }

      if (prevWorkflowJson) {
        detaisl = _.omit(JSON.parse(prevWorkflowJson), "updateTime");
      }
      const removeEmptyHeaders = (json) => {
        if (json?.tasks?.length) {
          for (let task of json.tasks) {
            const inputParameters = task?.inputParameters;
            const hasHeaders = inputParameters
              ? "headers" in inputParameters
              : false;
            const headers = hasHeaders ? inputParameters.headers : null;
            const isEmptyHeader = headers
              ? Object.keys(headers).length === 1 && headers[""] === ""
              : false;

            if (isEmptyHeader) {
              delete task.inputParameters.headers;
            }
          }
        }
        return json;
      };
      modifiedWorkflowJson = removeEmptyHeaders(modifiedWorkflowJson);
      detaisl = removeEmptyHeaders(detaisl);

      setIsModified(!_.isEqual(detaisl, modifiedWorkflowJson));
    }
  }, [tasks, hasEditorLoaded]);

  useEffect(() => {
    // reset taskErrors on workflow def init
    setTaskErrors([]);
  }, []);

  const deleteSwitchCaseFromTask = (parentTask, selectedCase) => {
    parentTask.decisionCases = _.omit(parentTask.decisionCases, selectedCase);
    setTasks(_.cloneDeep(tasks));
    closeTasksPopper();
    setTimeout(() => {
      handleWorkflowNodeClick({ ref: parentTask.taskReferenceName });
    }, TASK_CREATION_DELAY);
  };

  /* add task in appropriate place */
  function insertTask(
    allTasks,
    parentTaskReferenceName,
    switchDetails,
    taskObj,
    followingTasks = []
  ) {
    if (parentTaskReferenceName === "__start") {
      if (allTasks) {
        allTasks.splice(0, 0, taskObj);
        if (followingTasks.length > 0) {
          allTasks.splice(1, 0, ...followingTasks);
        }
        setTasks(_.cloneDeep(allTasks));
      }
      closeTasksPopper();
      return;
    }
    let { task, tasks, taskIndex } = findNode(
      allTasks,
      parentTaskReferenceName
    );

    if (task && task.type === TaskType.Switch) {
      if (!task.decisionCases || _.isEmpty(task.decisionCases)) {
        task.decisionCases = {};
      }
      // create case note node
      let caseNode = createTaskNode(
        switchDetails.caseName,
        switchDetails.caseName,
        TaskType.SwitchCase,
        TaskType.Label
      );
      task.decisionCases[switchDetails.caseName] = [
        caseNode,
        taskObj,
        ...followingTasks,
      ];
      setTasks(_.cloneDeep(allTasks));
    } else if (task && task.type === TaskType.ForkJoin) {
      if (!task.forkTasks || _.isEmpty(task.forkTasks)) {
        task.forkTasks = [[]];
      }
      let pathNo = task.forkTasks.length + 1;
      let forkBranchNode = createTaskNode(
        TaskType.ForkBranch + " PATH " + `${pathNo}`,
        TaskType.ForkBranch,
        TaskType.ForkBranch,
        TaskType.Label
      );
      let newForkBranch = [];
      newForkBranch.push(forkBranchNode);
      newForkBranch.push(taskObj);
      newForkBranch.push(...followingTasks);
      task.forkTasks.push(newForkBranch);

      setTasks(_.cloneDeep(allTasks));
    } else if (task && task.type === TaskType.DoWhile) {
      if (!task.loopOver || _.isEmpty(task.loopOver)) {
        task.loopOver = [];
      }
      task.loopOver.splice(0, 0, taskObj);
      if (followingTasks.length > 0) {
        task.loopOver.splice(1, 0, ...followingTasks);
      }
      setTasks(_.cloneDeep(allTasks));
    } else {
      tasks.splice(taskIndex + 1, 0, taskObj);
      if (followingTasks.length > 0) {
        tasks.splice(taskIndex + 2, 0, ...followingTasks);
      }

      setTasks(_.cloneDeep(allTasks));
    }

    setIsModified(true);
    closeTasksPopper();
  }

  function findNode(tasks, parentTaskReferenceName) {
    let taskIndex = -1;

    for (const task of tasks) {
      taskIndex++;
      if (task.taskReferenceName != parentTaskReferenceName) {
        if (task.type === TaskType.Switch) {
          const { defaultCase, decisionCases } = task;
          for (let index = 0; index < 2; index++) {
            if (index == 0) {
              const obj = findNode(defaultCase, parentTaskReferenceName);
              if (obj != null) {
                return obj;
              }
            } else if (index == 1) {
              if (decisionCases && !_.isEmpty(decisionCases)) {
                for (const key in decisionCases) {
                  const decisionCase = decisionCases[key];
                  const obj = findNode(decisionCase, parentTaskReferenceName);
                  if (obj != null) {
                    return obj;
                  }
                }
              }
            }
          }
        } else if (task.type === TaskType.ForkJoin) {
          if (task.forkTasks && task.forkTasks.length > 0) {
            for (let index = 0; index < task.forkTasks.length; index++) {
              const forktask = task.forkTasks[index];
              const obj = findNode(forktask, parentTaskReferenceName);
              if (obj != null) {
                return obj;
              }
            }
          }
        } else if (task.type === TaskType.DoWhile) {
          const { loopOver } = task;
          if (task.loopOver && task.loopOver.length > 0) {
            for (let index = 0; index < task.loopOver.length; index++) {
              const looptask = task.loopOver;
              const obj = findNode(looptask, parentTaskReferenceName);
              if (obj != null) {
                return obj;
              }
            }
          }
        } else if (taskIndex + 1 == tasks.length) {
          return null;
        }
      } else if (task.taskReferenceName === parentTaskReferenceName) {
        return { task, tasks, taskIndex };
      }
    }
  }

  const addTask = (newTask, switchTaskDetails = null) => {
    let parentTaskReferenceName = clickedAddBtnNode;
    let taskObj = null;

    if (newTask) {
      let refObj = { ref: "" };
      if (newTask.task === TaskType.Switch) {
        const { switchNode, endOfSwitchNode } = createSwitchComponent(newTask);
        if (switchNode && endOfSwitchNode) {
          insertTask(
            tasks,
            parentTaskReferenceName,
            switchTaskDetails,
            switchNode,
            [endOfSwitchNode]
          );
          refObj.ref = switchNode.taskReferenceName;
        }
      } else if (newTask.task === TaskType.ForkJoin) {
        const { forkJoinNode, joinNode, joinLabelNode } = createForkComponent();
        if (forkJoinNode && joinNode && joinLabelNode) {
          insertTask(
            tasks,
            parentTaskReferenceName,
            switchTaskDetails,
            forkJoinNode,
            [joinNode, joinLabelNode]
          );
          refObj.ref = forkJoinNode.taskReferenceName;
        }
      } else if (newTask.task === TaskType.DoWhile) {
        const { doWhileNode, endOfDoWhileNode } = createDoWhileComponent();

        if (doWhileNode && endOfDoWhileNode) {
          insertTask(
            tasks,
            parentTaskReferenceName,
            switchTaskDetails,
            doWhileNode,
            [endOfDoWhileNode]
          );

          refObj.ref = doWhileNode.taskReferenceName;
        }
      } else if (newTask.task === TaskType.TriggerApproval) {
        const {
          startTriggerApprovalNode,
          triggerApprovalNode,
          fetchApprovalNode,
          switchNode,
          endOfSwitchNode,
          endTriggerApprovalNode,
        } = createTriggerApprovalComponent(switchTaskDetails);

        if (startTriggerApprovalNode) {
          insertTask(
            tasks,
            parentTaskReferenceName,
            switchTaskDetails,
            startTriggerApprovalNode
          );
          parentTaskReferenceName = startTriggerApprovalNode.taskReferenceName;
        }

        if (triggerApprovalNode) {
          insertTask(
            tasks,
            parentTaskReferenceName,
            switchTaskDetails,
            triggerApprovalNode
          );
          parentTaskReferenceName = triggerApprovalNode.taskReferenceName;
        }
        if (fetchApprovalNode) {
          fetchApprovalNode["inputParameters"] = {
            requestApprovalStepsId:
              triggerApprovalNode.taskReferenceName +
              ".output.response.body.data.requestApprovalStepsId",
          };

          insertTask(
            tasks,
            parentTaskReferenceName,
            switchTaskDetails,
            fetchApprovalNode
          );
          parentTaskReferenceName = fetchApprovalNode.taskReferenceName;
        }

        if (switchNode && endOfSwitchNode) {
          insertTask(
            tasks,
            parentTaskReferenceName,
            switchTaskDetails,
            switchNode,
            [endOfSwitchNode]
          );

          parentTaskReferenceName = endOfSwitchNode.taskReferenceName;
        }
        if (endTriggerApprovalNode) {
          insertTask(
            tasks,
            parentTaskReferenceName,
            switchTaskDetails,
            endTriggerApprovalNode
          );
        }
        if (triggerApprovalNode) {
          refObj.ref = triggerApprovalNode.taskReferenceName;
        }
      } else if (newTask.task === TaskType.SubWorkflow) {
        const subWorkflowNode = createSubWorkflowComponent();
        if (subWorkflowNode) {
          insertTask(
            tasks,
            parentTaskReferenceName,
            switchTaskDetails,
            subWorkflowNode
          );

          refObj.ref = subWorkflowNode.taskReferenceName;
        }
      } else {
        taskObj = createTaskNode(
          newTask.task,
          newTask.task,
          newTask.task,
          newTask.task
        );
        insertTask(tasks, parentTaskReferenceName, switchTaskDetails, taskObj);
        refObj.ref = taskObj.taskReferenceName;
      }

      setTimeout(() => {
        if (refObj.ref) {
          handleWorkflowNodeClick(refObj);
        }
      }, TASK_CREATION_DELAY);
    }
  };

  const updateTaskFromTaskDefinationTab = (newVal, taskData) => {
    if (newVal) {
      let randomText = generateRandomText();

      let taskObj = {
        displayName: `${newVal.task.split("_").join(" ")}`,
        name: `${newVal.task}`,
        taskReferenceName: `${newVal.task}_${randomText}_ref`,
        type: newVal.task,
      };

      if (newVal.task === "SWITCH") {
        let randomText = generateRandomText();
        taskObj["defaultCase"] = [
          {
            displayName: "SIMPLE",
            name: "SIMPLE",
            taskReferenceName: `DEFAULT-CASE_${randomText}_ref`,
            type: "SIMPLE",
          },
        ];
      }
      let dataToBeModified = [];
      if (tasks) dataToBeModified = [...tasks];

      for (let i = 0; i < dataToBeModified.length; i++) {
        if (
          dataToBeModified[i].taskReferenceName === taskData.taskReferenceName
        ) {
          dataToBeModified[i] = taskObj;
          break;
        }
      }
      setTasks(dataToBeModified);
    }
  };

  const closeTasksPopper = () => {
    setShowTasksPopper(false);
    setClickedAddBtnNode(null);
    setClickedDeletePathBtnNode(null);
  };

  const updateTaskListWithTask = (taskObj, prevTaskObj) => {
    const list = updateTaskList(tasks, taskObj, prevTaskObj);
    setTasks(list);
  };

  const TaskPopper = useMemo(() => {
    if (showTasksPopper && clickedDeletePathBtnNode) {
      const taskObj = getTaskObj(tasks, clickedDeletePathBtnNode);
      if (taskObj) {
        const { type } = taskObj;

        if (type === "SWITCH") {
          return (
            <SwitchCasesPopperUI
              open={showTasksPopper}
              anchorEl={clickedDeletePathBtnNode}
              setShowTasksPopper={setShowTasksPopper}
              closeTasksPopper={closeTasksPopper}
              task={taskObj}
              updateTaskListWithTask={updateTaskListWithTask}
              deleteSwitchCaseFromTask={deleteSwitchCaseFromTask}
            />
          );
        } else if (type === TaskType.ForkJoin) {
          return (
            <ForkPathsPopperUI
              open={showTasksPopper}
              anchorEl={clickedDeletePathBtnNode}
              setShowTasksPopper={setShowTasksPopper}
              closeTasksPopper={closeTasksPopper}
              task={taskObj}
              updateTaskListWithTask={updateTaskListWithTask}
              // deleteForkPathFromTask={deleteForkPathFromTask}
              deleteForkPathFromTask={handleDeleteForkPath}
              selectedCase={selectedForkCase}
              setSelectedCase={setSelectedForkCase}
            />
          );
        }
      } else {
        return null;
      }
    } else if (showTasksPopper && clickedAddBtnNode) {
      const taskObj = getTaskObj(tasks, clickedAddBtnNode);
      if (taskObj) {
        const { type } = taskObj;

        if (type === TaskType.Switch) {
          return (
            <SwitchTaskPopperUI
              open={showTasksPopper}
              anchorEl={clickedAddBtnNode}
              setShowTasksPopper={setShowTasksPopper}
              task={taskObj}
              updateTaskListWithTask={updateTaskListWithTask}
              addTask={addTask}
            />
          );
        } else {
          return (
            <TaskPopperUi
              open={showTasksPopper}
              anchorEl={clickedAddBtnNode}
              setShowTasksPopper={setShowTasksPopper}
              setClickedAddBtnNode={setClickedAddBtnNode}
              setTaskSelectedFromList={handleTaskSelectedFromList}
              addTask={addTask}
            />
          );
        }
      } else if (clickedAddBtnNode == "__start") {
        return (
          <TaskPopperUi
            open={showTasksPopper}
            anchorEl={clickedAddBtnNode}
            setShowTasksPopper={setShowTasksPopper}
            setClickedAddBtnNode={setClickedAddBtnNode}
            setTaskSelectedFromList={handleTaskSelectedFromList}
            addTask={addTask}
          />
        );
      }

      {
        return null;
      }
    } else {
    }
    setTasks(_.cloneDeep(tasks));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clickedAddBtnNode, showTasksPopper]);

  const ConformationDialog = useMemo(() => {
    const { openDialog, header, message, ref } = clickedDeleteBtnNode;
    if (openDialog) {
      return (
        <ConfirmChoiceDialog
          header={header}
          message={message}
          handleConfirmationValue={(confirm) =>
            handleConfirmDelete({ ref, confirm })
          }
          open={openDialog}
        />
      );
    } else {
      return null;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clickedDeleteBtnNode]);

  const setIsNodeOnClickEnabled = (val) => {
    setLoading(val);
  };

  const toggleSplitPanel = (minimize = true) => {
    if (minimize) {
      setSplitMinSizes([0, 0]);
      setSplitMaxSizes([Infinity, 0]);
      setSplitSizes([100, 0]);
    } else {
      setSplitMinSizes([0, 500]);
      setSplitMaxSizes([Infinity, 800]);
      setSplitSizes([50, 50]);
    }
    dispatch({ type: actions.TOGGLE_GRAPH_PANEL });
  };

  return (
    <>
      <Helmet>
        <title>
          Conductor UI - Workflow Definition - {workflowName || "New Workflow"}
        </title>
      </Helmet>

      <ResetConfirmationDialog
        version={resetDialog}
        onConfirm={changeVersionOrReset}
        onClose={() => setResetDialog(false)}
      />

      <SaveWorkflowDialog
        document={saveDialog}
        onCancel={handleSaveCancel}
        onSuccess={handleSaveSuccess}
        versions={versions}
      />

      {isFetching && <LinearProgress />}
      {/* {isLoading && <DefaultLoader
       displayModal={true}
       message={'test'}


      />} */}
      <div className={classes.wrapper}>
        <Split
          className="flex-row"
          sizes={splitSizes}
          minSize={splitMinSizes}
          maxSize={splitMaxSizes}
          gutterSize={DEFAULT_GUTTER_SIZE}
          gutterAlign="center"
          direction="horizontal"
          cursor="col-resize"
        >
          <div className={classes.workflowGraph}>
            {dag && (
              <WorkflowGraph
                dag={dag}
                onClick={isTaskDataLoading ? () => { } : handleWorkflowNodeClick}
                onAddBtnClick={handleWorkflowAddBtnClick}
                onSubtractBtnClick={handleSwitchCaseDeleteBtnClick}
                onDeleteBtnClick={handleWorkflowDeleteBtnClick}
                navigate={navigate}
                // setSelectedTask={setSelectedTask}
                selectedTask={selectedTask}
                isLoading={isLoading}
                setIsLoading={updateLoading}
                hasEditorLoaded={hasEditorLoaded}
                componentLoadedFrom={"Definition"}
                isModified={!_.isNull(isModified) && isModified}
                onExpand={handleExpandChange}
                onCollapse={handleCollapseChange}
                dpr={dpr}
              />
            )}

            <IconButton
              onClick={() => {
                toggleSplitPanel(false);
              }}
              className={`${classes.togglebtn}`}
            >
              {workflowDefState.toggleGraphPanel && (
                <KeyboardArrowRightRounded />
              )}
              {!workflowDefState.toggleGraphPanel && (
                <KeyboardArrowLeftRounded />
              )}
            </IconButton>
          </div>
          <div className={classes.workflowCodePanel}>
            <WorkflowToolbar
              classes={classes}
              workflowDisplayName={workflowDisplayName}
              isModified={isModified}
              jsonErrors={jsonErrors}
              taskErrors={taskErrors}
              jsonParseError={jsonParseError}
              permissionConfig={permissionConfig}
              workflowDef={workflowDef}
              selectedVersion={selectedVersion}
              validSelectedVersion={validSelectedVersion}
              workflowVersion={workflowVersion}
              handleResetVersion={handleResetVersion}
              versions={versions}
              handleOpenSave={handleOpenSave}
              toggleSplitPanel={toggleSplitPanel}
              workflowDefState={workflowDefState}
            />
            <div className={classes.workflowDefTabs}>
              <Tabs
                value={value}
                onChange={handleTabChange}
                indicatorColor="primary"
                textColor="primary"
                aria-label="basic tabs"
              >
                <Tab label="Workflow" />
                <Tab label="Task" />
                <Tab label="Code" />
              </Tabs>
            </div>
            <div
              className={classes.workflowDefTabPannels}
              hidden={value !== 0}
              value={value}
              index={0}
            >
              <WorkflowDefinationForm
                innerRef={workflowFormRef}
                dataToBeAddedToJSON={dataToBeAddedToJSON}
                setDataToBeAddedToJson={setDataToBeAddedToJson}
                // workflowDef={workflowDef}
                workflowDef={
                  newWorkflow ? JSON.parse(newWorkflow) : workflowDef
                }
                durationVal={duration}
                workflowDays={workflowDays}
                workflowHours={workflowHours}
                workflowMinutes={workflowMinutes}
                workflowSeconds={workflowSeconds}
                setWorkflowDays={setWorkflowDays}
                setWorkflowHours={setWorkflowHours}
                setWorkflowMinutes={setWorkflowMinutes}
                setWorkflowSeconds={setWorkflowSeconds}
                setDuration={setDuration}
                handleDaysChange={handleDaysChange}
                handleHoursChange={handleHoursChange}
                handleMinutesChange={handleMinutesChange}
                handleSecondsChange={handleSecondsChange}
              />
            </div>
            <div
              className={`${classes.workflowDefTabPannels} ${classes.taskPanel} `}
              hidden={value !== 1}
              value={value}
              index={1}
            >
              <TaskDefinationTab
                tasks={tasks}
                setTasks={setTasks}
                inputParameters={inputParameters}
                id="workflowDef-taskTab"
                clickedWorkflowNodeTaskRef={clickedWorkflowNodeTaskRef}
                setClickedWorkflowNodeTaskRef={setClickedWorkflowNodeTaskRef}
                changeTask={updateTaskFromTaskDefinationTab}
                setIsNodeOnClickEnabled={setIsNodeOnClickEnabled}
                isEditorMounted={isEditorMounted}
                setIsTaskDataLoading={setIsTaskDataLoading}
                setTaskData={setTaskData}
                taskData={taskData}
                setClickedTask={setClickedTask}
                clickedTask={clickedTask}
                selectedVersion={selectedVersion}
                workflowDef={
                  newWorkflow ? JSON.parse(newWorkflow) : workflowDef
                }
                nodeClicked={nodeClicked}
                onModifiedJQ={setIsModified}
                onJsonErrors={handleJsonErrors}
                setEditorDelay={setEditorDelay}
                workflowName={workflowName}
                permissionConfig={permissionConfig}
              />
            </div>
            {isCodeModified && permissionConfig?.canCreateWorkflow ? (
              <div>
                <span className={classes.saveCode}>
                  {jsonParseError || !_.isEmpty(jsonErrors) ? (
                    <Text style={{ color: "red" }}>
                      You have some errors. Please fix them before saving code.
                    </Text>
                  ) : (
                    <Text>
                      Code modified. Please save to view your changes.
                    </Text>
                  )}
                  <div className={classes.rightCodeBtn}>
                    <Button
                      disabled={!_.isEmpty(jsonErrors) || jsonParseError}
                      onClick={handleOpenSave}
                    >
                      Save Code
                    </Button>
                  </div>
                </span>
              </div>
            ) : null}
            <div
              // className={classes.workflowDefTabPannels}
              hidden={
                value !== 2 || permissionConfig?.canAccessCodeEditor === false
              }
              value={value}
              index={2}
              style={{ height: "100vh" }}
            >
              <SafeEditor
                height="100%"
                width="100%"
                theme="vs-light"
                language="json"
                value={workflowJsonWithoutSubWf}
                autoIndent={true}
                beforeMount={handleEditorWillMount}
                onMount={handleEditorDidMount}
                onValidate={handleValidate}
                onChange={(newValue, event) =>
                  handleEditorChange(
                    newValue,
                    workflowJson,
                    setIsModified,
                    setTasks
                  )
                }
                options={{
                  readOnly: !permissionConfig.canCreateWorkflow,
                  smoothScrolling: true,
                  selectOnLineNumbers: true,
                  minimap: {
                    enabled: false,
                  },
                }}
                path={JSON_FILE_NAME}
              />
            </div>
          </div>
        </Split>
      </div>
      {TaskPopper}
      {ConformationDialog}
    </>
  );
}
